import { render, staticRenderFns } from "./TextCount.vue?vue&type=template&id=71341c80"
import script from "./TextCount.vue?vue&type=script&lang=js"
export * from "./TextCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports